import React from 'react';
import { Link } from 'react-router-dom';
import TextLink from 'components/TextLink';
import { jsx as _jsx } from "react/jsx-runtime";
function SettingsLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(TextLink, {
    as: Link,
    to: "/settings",
    children: children
  });
}
export default SettingsLink;